export { default, type LoaderProps } from './Loader';
